module.exports = __webpack_public_path__ + "Poppins-ExtraBold.19da688be928e111c455.woff";


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/assets/vendors/base/fonts/googleapi-fonts/Poppins-ExtraBold.woff
// module id = ../../../../../src/assets/vendors/base/fonts/googleapi-fonts/Poppins-ExtraBold.woff
// module chunks = styles